export default __webpack_public_path__ + "media/images/logo-gsy-0689e6c47249d9a30f2d5d6cf1d6e394.png";